"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamePointIcon = exports.default = void 0;
var GamePoints_1 = require("./GamePoints");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(GamePoints_1).default; } });
var GamePointIcon_1 = require("./GamePointIcon");
Object.defineProperty(exports, "GamePointIcon", { enumerable: true, get: function () { return __importDefault(GamePointIcon_1).default; } });
